import { useAppData } from "../state/AppData";
import { PROVENANCE_SCOPE_LABEL } from '../lib/definitions/trust';

// The checkbox should read like "if the
// box is checked you see the whole mesh's feed, if it's not you see only
// this radio." The first version's own label CHANGED with state ("This
// radio only" checked, "Everything we can see" unchecked) — forcing the
// reader to work out which way the boolean ran, and easy to invert. Fixed
// by inverting the underlying control, not just relabeling: a checkbox's
// own label must describe what CHECKING it does and must never change.
//
// Unchecked (the default) = this radio only. Checked = the full firehose.
// The default provenance scope itself is unchanged (still connected-radio
// — see lib/definitions.ts's DEFAULT_PROVENANCE_SCOPE) — only which
// boolean state that maps to changed, from checked to unchecked.
//
// Moved out of the top bar into the status strip 2026-09-20 — it
// made it feel like it wasn't part of the current "module" that is the
// tab; the top bar is global chrome, this is a per-view filter on the
// Live Map, same module the "Filtered:" badge already reports this
// control's effect in) — see StatusStrip.tsx.
//
// 2026-09-27 first-installer review (part5d, item 4): this control used to
// carry its own two-line description ("Show the whole mesh's feed" / "This
// radio's own reception only.") on top of the "Filtered:" chip in
// StatusStrip and a third restatement in LiveMap's own bottom caption —
// the same fact said three different ways. Reduced to the one shared
// label pair (PROVENANCE_SCOPE_LABEL, "This radio only" / "Whole mesh"),
// reused verbatim by the chip too. The checkbox's own visible text stays
// the FIXED "Whole mesh" label — what checking it turns on — per this
// file's own rule above that a checkbox's label must never change with
// its state; only the chip reports the current live value.
export function ProvenanceToggle() {
  const { provenanceScope, setProvenanceScope } = useAppData();
  const showFirehose = provenanceScope === "firehose";

  return (
    <label className="provenance-toggle">
      <input
        type="checkbox"
        checked={showFirehose}
        onChange={(e) => setProvenanceScope(e.target.checked ? "firehose" : "connected_radio")}
      />
      <span className="provenance-toggle-text">{PROVENANCE_SCOPE_LABEL.firehose}</span>
    </label>
  );
}
